
<template>
  <component :is="Component" @prev-page="prevPage($event)" @calc-results="calcResults"  @next-page="nextPage($event)" @CheckStatus="CheckUserStatus" @complete="complete" v-bind="Props" />
</template>
<script>
  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/

  import { defineAsyncComponent } from 'vue'
  import LoadingSpinner from '@/components/LoadingSpinner.vue';

  export default {
    props: ['AssessmentType', 'AssessmentId'],
    data: () => ({
      CreateAssessmentComponents: {
        PartOne: defineAsyncComponent(() => import('./PartOne.vue')),
        AssessmentQuestions: defineAsyncComponent(() => import('./PartTwo.vue')),
        AssessmentResults: defineAsyncComponent(() => import('./PartThree.vue'))
      },
      Component: null,
      Props: null,
    }),
    async created() {
      var self = this;
      self.$emit("set-nav", this.$route)

      if (this.$route.query.Email != null) {
        self.Props = {
          AssessmentId: this.AssessmentId == null ? 32 : this.AssessmentId,
          Email: this.$route.query.Email
        }
        self.Component = self.CreateAssessmentComponents.PartOne;
      }
      else {

        self.Props = {
          AssessmentId: this.AssessmentId == null ? 32 : this.AssessmentId
        }
        self.Component = self.CreateAssessmentComponents.PartOne;
      }
    },
    methods: {
      nextPage(event) {
        this.Props = event;
        this.Component = this.CreateAssessmentComponents.AssessmentQuestions
      },
      calcResults(event) {
        this.Props = event;
        this.Component = this.CreateAssessmentComponents.AssessmentResults
      },
      prevPage(event) {
        this.Props = event.Props;
      },
    }
  }
</script>

